const config = {
  bucket_name: process.env.REACT_APP_BUCKET_SLUG || "acd039a0-d747-11ec-8566-cbb1022da448",
  bucket_slug: process.env.REACT_APP_BUCKET_SLUG || "acd039a0-d747-11ec-8566-cbb1022da448",
  bucket_id: process.env.REACT_APP_BUCKET_ID || "6285f5a2fe3b49000998ed54",
  read_key: process.env.REACT_APP_BUCKET_READ_KEY || "0OnxqAJE4BpBEa7eqdCWlCAHDJJjG7RR9sRVES19VwOQXjfh9F",
  write_key: process.env.REACT_APP_BUCKET_WRITE_KEY || "fb2tkS5WoGId3yhvnZxfcx4PrODwOFn95nsTToxfkqqLN6zFLL",
  url: "https://api.cosmicjs.com/v1/"
}
export default config;